export default __webpack_public_path__ + "static/media/profile__new.54b7ae25.png";